/**
 * Decode JWT payload without validation (browser-side expiry check only).
 * Returns null if the token is not a valid JWT structure.
 */
export function decodeJWTPayload(token: string): { exp?: number;[key: string]: unknown } | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    let b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    // Pad to multiple of 4 — atob requires proper base64 padding
    const pad = b64.length % 4;
    if (pad) b64 += '='.repeat(4 - pad);
    // JWT payload is UTF-8 JSON. atob returns binary string; convert bytes to UTF-8 text.
    const binary = atob(b64);
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
    const payload = JSON.parse(new TextDecoder().decode(bytes));
    return payload;
  } catch {
    return null;
  }
}
